/********************************************************************************
 * Copyright (c) 2022 Cedalo GmbH
 *
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the Eclipse Public License 2.0 which accompany this distribution.
 * and Eclipse Distribution License v1.0 which accompany this distribution.
 *
 * The Eclipse Public License is available at
 *   https://www.eclipse.org/legal/epl-2.0/
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const END_REGEX = new RegExp('[/]*$');
const START_REGEX = new RegExp('^[/]*');

const topics = {
	clean: (topic) => topic.replace(START_REGEX, '').replace(END_REGEX, ''),
	normalize: (topic) => (topic ? `${topics.clean(topic)}/` : topic),
	addBaseTopic: (basetopic) => {
		if (basetopic) {
			basetopic = topics.clean(basetopic);
			return (topic) => `${basetopic}/${topics.clean(topic)}`;
		}
		return (topic) => topics.clean(topic);
	},
	join: (topic, basetopic) => (basetopic ? `${topics.clean(basetopic)}/${topics.clean(topic)}` : topics.clean(topic))
};

module.exports = {
	topics
};
